

export function byCollegeDetails(callback) {
  let str = localStorage.getItem('byCollegeDetails')
  if (str) {
    let json = JSON.parse(str)
    callback(json)
  }
}
export function getLocalDepartment() {
  let department = localStorage.getItem('department')
  if (department) {
    let json = JSON.parse(department)
    return json
  }
}
export default {
  getbyCollegeDetails: byCollegeDetails,
  getLocalDepartment: getLocalDepartment
}



// WEBPACK FOOTER //
// ./src/tool/localManager.js